// src/Public/BottomNav.js
import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/BottomNav.css";

const BottomNav = () => (
  <div className="bottom-nav-container">
    <nav
      className="bottom-nav-dock bottom-nav-dock-standard"
      style={{
        borderRadius: "26px",
        maxWidth: "420px",
      }}
    >
      <div className="bottom-nav-items" style={{ padding: "8px 12px" }}>
        <NavLink
          to="/"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-home"></i>
          </span>
          <div>Home</div>
        </NavLink>

        <NavLink
          to="/public/contact"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-headset"></i>
          </span>
          <div>Support</div>
        </NavLink>

        <NavLink
          to="/public/privacypolicy"
          className={({ isActive }) => `bottom-nav-tab ${isActive ? "active" : ""}`}
        >
          <span>
            <i className="fi fi-rr-shield-check"></i>
          </span>
          <div>Privacy</div>
        </NavLink>
      </div>
    </nav>
  </div>
);

export default BottomNav;
